import { CliPage, LazyPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function CliIndexRoute() {
  return (
    <LazyPage>
      <CliPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/cli/')({
  component: CliIndexRoute,
});
